<div class="tour-listing-header">
    <svg width="151" height="42" viewBox="0 0 151 42" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_105_703)">
            <path
                d="M77.657 18.4488C77.657 24.4652 73.0651 27.2678 67.5236 27.2678H64.2403V34.8129H58.0039V9.29395H67.5178C73.8642 9.29395 77.657 12.942 77.657 18.4488ZM71.3106 18.4488C71.3106 16.48 69.9266 15.2061 67.5178 15.2061H64.2345V21.6973H67.5178C69.7819 21.6915 71.3106 20.6724 71.3106 18.4488Z"
                fill="black"></path>
            <path
                d="M96.9391 27.3778H83.5977C84.2172 29.5261 85.966 30.5105 88.2301 30.5105C90.1236 30.5105 91.4381 29.6014 92.0229 28.9065L96.1805 31.3849C94.6866 33.6837 91.8434 35.2877 88.2359 35.2877C81.9995 35.2877 77.8477 31.3502 77.8477 25.5886C77.8477 20.1223 82.1153 15.8894 87.3963 15.8894C92.8567 15.8952 97.6687 19.6127 96.9391 27.3778ZM91.5828 23.8051C91.1427 21.6568 89.614 20.6724 87.57 20.6724C85.7112 20.6724 84.142 21.7668 83.5977 23.8051H91.5828Z"
                fill="black"></path>
            <path
                d="M105.248 21.2166V27.0476C105.248 28.9817 105.943 29.9661 107.761 29.9661C108.236 29.9661 108.601 29.8908 108.89 29.856V34.8127C108.271 35.0328 107.506 35.1428 106.337 35.1428C100.65 35.1428 99.336 31.2805 99.336 27.6672V21.2166H97.0371V16.3293H99.336V12.467H105.242V16.3293H108.89V21.2166H105.248Z"
                fill="black"></path>
            <path
                d="M123.003 15.895V22.2357C117.751 21.4308 117.172 24.4245 117.172 27.5224V34.8127H111.266V16.3293H117.172V19.1377C118.481 17.0589 120.814 15.895 123.003 15.895Z"
                fill="black"></path>
            <path
                d="M124.311 11.1526C124.311 9.43863 125.694 8.05469 127.408 8.05469C129.122 8.05469 130.506 9.43863 130.506 11.1526C130.506 12.8666 129.122 14.2853 127.408 14.2853C125.7 14.2911 124.311 12.8666 124.311 11.1526ZM124.461 16.3294H130.367V34.8128H124.461V16.3294Z"
                fill="black"></path>
            <path
                d="M150.925 27.3778H137.584C138.204 29.5261 139.952 30.5105 142.216 30.5105C144.11 30.5105 145.424 29.6014 146.009 28.9065L150.167 31.3849C148.673 33.6837 145.83 35.2877 142.222 35.2877C135.986 35.2877 131.834 31.3502 131.834 25.5886C131.834 20.1223 136.102 15.8894 141.383 15.8894C146.843 15.8952 151.655 19.6127 150.925 27.3778ZM145.569 23.8051C145.129 21.6568 143.6 20.6724 141.562 20.6724C139.703 20.6724 138.134 21.7668 137.59 23.8051H145.569Z"
                fill="black"></path>
            <path
                d="M29.2886 0C19.4273 0 11.1642 6.81547 8.9406 15.9935C7.02972 13.3819 3.79281 9.56598 0 7.63194C1.99195 9.47333 3.43379 14.789 3.43379 21.0602C3.43379 26.9492 2.16566 31.9928 0.359014 34.1179C2.22357 32.7976 6.3059 29.6823 8.95797 25.9532C9.98869 30.1572 12.2933 33.8573 15.4376 36.6368C14.5632 37.5922 13.6599 38.5361 12.7681 39.5031C12.7797 39.5089 12.8029 39.5378 12.8318 39.5494C13.0056 39.5899 13.1851 39.6305 13.3588 39.6594C15.9298 40.1169 18.4892 40.2848 21.0313 40.1864C23.5675 41.275 26.3586 41.883 29.2944 41.883C40.8581 41.883 50.2388 32.5081 50.2388 20.9386C50.233 9.37489 40.8581 0 29.2886 0ZM31.4832 38.4203C29.3928 38.4203 27.4009 38.0091 25.5768 37.2679C25.2873 37.378 24.9804 37.4996 24.6503 37.6212C22.1546 38.5592 19.5026 38.6229 16.8621 38.2465C16.7752 38.235 16.6883 38.2176 16.6015 38.2002C16.5841 38.1944 16.5725 38.1828 16.5667 38.1771C17.1863 37.4532 17.8175 36.7642 18.4023 36.0346C19.0451 35.2297 19.5662 34.3495 20.0179 33.4288C17.4064 30.632 15.8082 26.8739 15.8082 22.7453C15.8082 14.0884 22.8263 7.07025 31.4832 7.07025C40.14 7.07025 47.1582 14.0884 47.1582 22.7453C47.1582 31.4021 40.14 38.4203 31.4832 38.4203Z"
                fill="url(#paint0_linear_105_703)"></path>
            <path
                d="M39.6882 19.4504C37.9973 19.4504 36.596 20.6607 36.2949 22.2646C36.4397 22.1083 36.6366 21.9983 36.8682 21.9693C37.3893 21.9056 37.8642 22.2704 37.9279 22.7916C37.9916 23.3127 37.6267 23.7876 37.1056 23.8513C36.7929 23.8918 36.4976 23.7702 36.3007 23.5559C36.6018 25.1541 38.0089 26.3643 39.694 26.3643C41.6049 26.3643 43.1509 24.8183 43.1509 22.9074C43.1451 20.9965 41.5933 19.4504 39.6882 19.4504Z"
                fill="black"></path>
        </g>
        <defs>
            <linearGradient id="paint0_linear_105_703" x1="25.1194" y1="0" x2="25.1194" y2="41.883"
                gradientUnits="userSpaceOnUse">
                <stop stop-color="#12B5F9"></stop>
                <stop offset="1" stop-color="#7C27D5"></stop>
            </linearGradient>
            <clipPath id="clip0_105_703">
                <rect width="151" height="41.883" fill="white"></rect>
            </clipPath>
        </defs>
    </svg>
    <input
        type="text"
        placeholder="Search..."
        class="form-control ms-auto"
        [(ngModel)]="searchTerm"
        />
</div>
<div class="p-3">
    <div class="page-title d-flex justify-content-between align-items-center px-1">
        <h3>Manage Tours</h3>
        <div class="d-flex gap-2">
        </div>
    </div>

    <div *ngIf="loading" class="alert alert-info mt-3">Loading your tours...</div>

    <div *ngIf="!loading && error" class="alert alert-danger mt-3">
        {{ error }}
    </div>
    
    <div class="data-table-container p-3 m-1 mt-3" *ngIf="!loading && !error && tours.length">
        <p-table #dt2
            [value]="tours"
            [totalRecords]="totalRecords"
            [loading]="loading"
            [rows]="rowsPerPage"
            [paginator]="true"
            [rowsPerPageOptions]="[10,20,50]"
            [showCurrentPageReport]="true"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries">
            <ng-template pTemplate="header">
                <tr>
                    <th >Tour ID</th>
                    <th >Property name </th>
                    <th >Tour date and time</th>
                    <th >Tour status</th>
                    <th>Actions</th>
                </tr>
            </ng-template>

            <ng-template pTemplate="body" let-tour>
                <tr>
                    <td>{{ tour.tour_id || '—' }}</td>
                    <td>{{ tour.property_id?.name || '—' }}</td>
                    <td>{{ tour.date+' '+tour.time | timezoneDate:tour?.property_id?.timezone:'datetime' }}</td>
                    <td [ngClass]="'status' + tourStatus(tour).class">
                        <span>{{ tourStatus(tour).text }}</span>
                    </td>
                    <td>
                        <div class="d-flex align-items-center gap-2">
                            <p-button pButton icon="pi pi-times" class="icon-primary-btn"
                            *ngIf="!isAutoCancelLink"
                            (click)="confirmCancelTour(tour)"></p-button>
                            <p-button pButton icon="pi pi-calendar" class="icon-primary-btn"
                            (click)="confirmReschedulelTour(tour)"></p-button>
                        </div>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>

    <div *ngIf="!loading && !tours.length && !error" class="alert alert-info" role="alert">
        No follow-ups available.
    </div>
</div>

<!-- Cancel Tour Confimraiton Dialog -->
<p-dialog header="Cancel Tour" [(visible)]="cancelTourDialog" modal="true" [closable]="false" [responsive]="true"
    [style]="{width: '350px'}">
    <div class="confirmation-content">
        <p>Are you sure you want to cancel this tour?</p>
    </div>
    <div class="d-flex justify-content-end gap-2 mt-3">
        <p-button label="No" (click)="closeDialogue()" [disabled]="isConfirmLoading"></p-button>
        <p-button label="Yes" class="p-button-danger" (click)="cancelTour()" [loading]="isConfirmLoading"></p-button>
    </div>
</p-dialog>

<!-- Reschedule Tour Confimraiton Dialog -->
<p-dialog header="Reschedule Tour" [(visible)]="rescheduleTourDialog" modal="true" [closable]="false" [responsive]="true"
    [style]="{width: '350px'}">
    <div class="confirmation-content">
        <p>Are you sure you want to reschedule this tour?</p>
    </div>
    <div class="d-flex justify-content-end gap-2 mt-3">
        <p-button label="No" (click)="closeDialogue()" [disabled]="isConfirmLoading"></p-button>
        <p-button label="Yes" class="p-button-danger" (click)="rescheduleTourConfirm()" [loading]="isConfirmLoading"></p-button>
    </div>
</p-dialog>

<!-- Date & Time Selection Dialog -->
<p-dialog 
  header="Reschedule Tour" 
  [(visible)]="dateTimeDialog" 
  modal="true" 
  [closable]="false" 
  [responsive]="true"
  [style]="{width: '100%',maxWidth:'900px'}">

  <div class="row">
  <div class="col-md-6">
    <h5>Select a new date</h5>
    <p-calendar 
      [(ngModel)]="selectedDate"
      [inline]="true"
      [showIcon]="false"
      [touchUI]="false"
      [minDate]="minDate"
      [maxDate]="maxDate"
      [style]="{ width: '100%' }"
      class="text-center"
      (onSelect)="onDateSelect($event)">
    </p-calendar>
  </div>

  <div class="col-md-6">
    <h5>Select a time slot</h5>
    <div class="time-slot-grid mt-3">
      <button 
        *ngFor="let time of availableTimes" 
        pButton 
        [label]="time" 
        [class.p-button-outlined]="selectedTime !== time" 
        [class.p-button-primary]="selectedTime === time"
        (click)="selectedTime = time">
      </button>
    </div>
  </div>
  </div>
<ng-template pTemplate="footer">
    <div class="d-flex align-items-center justify-content-end gap-2">
        <p-button label="Cancel" (click)="closeDialogue()"></p-button>
        <p-button label="Reschedule" class="p-button-success" [disabled]="!selectedTime" [loading]="isConfirmLoading"
            (click)="rescheduleTour()">
        </p-button>
    </div>
</ng-template>
</p-dialog>
<!-- <p-dialog 
  header="Reschedule Tour" 
  [(visible)]="dateTimeDialog" 
  modal="true" 
  [closable]="false" 
  [responsive]="true">

  <div *ngIf="step === 1">
    <h5>Select a new date</h5>
    <p-calendar 
      [(ngModel)]="selectedDate"
      [inline]="true"
      [showIcon]="false"
      [touchUI]="false"
      [style]="{ width: '100%' }">
    </p-calendar>

    <div class="d-flex justify-content-end gap-2 mt-3">
      <p-button label="Cancel" (click)="closeDialogue()"></p-button>
      <p-button 
        label="Next" 
        [disabled]="!selectedDate"
        class="p-button-primary"
        (click)="goToTimeSelection()">
      </p-button>
    </div>
  </div>

  <div *ngIf="step === 2">
    <h5>Select a time slot</h5>
    <div class="time-slot-grid mt-3">
      <button 
        *ngFor="let time of availableTimes" 
        pButton 
        [label]="time" 
        [class.p-button-outlined]="selectedTime !== time" 
        [class.p-button-primary]="selectedTime === time"
        (click)="selectedTime = time">
      </button>
    </div>

    <div class="d-flex justify-content-between gap-2 mt-4">
      <p-button label="Back" (click)="step = 1"></p-button>
      <p-button 
        label="Reschedule" 
        class="p-button-success"
        [disabled]="!selectedTime"
        [loading]="isConfirmLoading"
        (click)="rescheduleTour()">
      </p-button>
    </div>
  </div>
</p-dialog> -->

<p-toast></p-toast>